const INTERACTIVE_SELECTOR =
  'button, a, input, textarea, select, label, [role="button"], [role="checkbox"], .ant-select'

export const createSafeRowMouseUp = (onSafeClick: () => void) => {
  return (event: Pick<React.MouseEvent, 'button' | 'target'>) => {
    if (event.button !== 0) return
    if (
      event.target instanceof Element &&
      event.target.closest(INTERACTIVE_SELECTOR)
    )
      return
    const selection = window.getSelection()
    const hasSelection = selection && selection.toString().trim().length > 0
    if (hasSelection) return
    onSafeClick()
  }
}
